import axios, { type AxiosError } from 'axios';

import isObj from 'utils/isObj';

type ModelState = Record<string, string[]>;
type Error = { Message?: string; ModelState: ModelState };

function hasModelState(err: object): err is Error {
  return (
    Object.hasOwn(err, 'ModelState') &&
    isObj((err as { ModelState: unknown }).ModelState)
  );
}

export default function isServerValidationError(
  err: unknown
): err is AxiosError<Error> {
  return (
    axios.isAxiosError(err) &&
    err.response?.status === 400 &&
    hasModelState(err.response?.data)
  );
}
